export const contactsData = {
  instagram_feed: {
    title_ua: 'Більше в моєму Instagram',
    title_ru: 'Больше в моём Instagram',
    instagram: {
      title_ua: 'Перейти \nв профіль \n@yana.sho',
      title_ru: 'Перейти \nв профиль \n@yana.sho',
      link: 'https://www.instagram.com/yana.sho/',
    },
  },
  socials: [
    { title: 'Tik Tok', link: 'https://www.tiktok.com/uk-UA/' },
    { title: 'Instagram', link: 'https://www.instagram.com/yana.sho/' },
    { title: 'Facebook', link: 'https://www.facebook.com/itsshoschool/' },
  ],
  messengers: [
    { title: 'telegram', link: 'https://t.me/itsyanasho' },
    { title: 'whatsapp', link: 'https://wa.me/380962757698' },
    { title: 'skype', link: 'skype:SHOSchool?call' },
    { title: 'viber', link: 'viber://chat?number=%2B380962757698' },
  ],
  phone: '+380 (96) 275 76 98',
  mail: 'shoschoooool@gmail.com',
};
